// extracted by mini-css-extract-plugin
export var motto = "about-me-module--motto--hyZbs";